export default "__VITE_ASSET__BBlnSea$__"